import type { DatapointStatus } from "owa-analytics-types";

/**
 * The performance-logging lifecycle used by a token acquisition request.
 *
 * Instrumented flows provide a real `LogStartPerformanceUsage` instance, while
 * flows whose telemetry is intentionally suppressed use the no-op implementation
 * below. Keeping this contract required prevents telemetry policy decisions from
 * leaking into token, queue, retry, and callback APIs as optional state.
 */
export interface TokenPerformanceLogger {
    addCheckpoint(name: string): void;
    addCustomProperty(key: string, value: string | number | boolean | undefined | null): void;
    end(): void;
    endWithError(status: DatapointStatus): void;
}

/**
 * Null-object implementation for token flows that must not emit performance telemetry.
 *
 * This preserves the required request-lifecycle contract without allocating or
 * publishing a datapoint. It should only represent deliberate telemetry suppression,
 * not hide failures to construct an expected real logger.
 */
export const noopTokenPerformanceLogger: TokenPerformanceLogger = Object.freeze({
    addCheckpoint: (_name: string): void => {
        return;
    },
    addCustomProperty: (_key: string, _value: string | number | boolean | undefined | null): void => {
        return;
    },
    end: (): void => {
        return;
    },
    endWithError: (_status: DatapointStatus): void => {
        return;
    },
});
